/**
 * 후원 안내는 게임 안에서 먼저 읽고, 외부 페이지는 사용자가 직접 연다.
 *
 * 은행 이체 링크에는 게임 계정 webhook이 없다. 따라서 자동 지급인 것처럼 보이게
 * 만들지 않고, 닉네임 표기 → 운영자 확인 → 계정 창고 지급의 실제 흐름을 말한다.
 * 외부 주소는 index.html의 한 anchor에만 두어 수정할 곳이 갈라지지 않게 한다.
 */
export function initSupport() {
  const modal = document.querySelector('#support-modal');
  const close = document.querySelector('#support-close');
  const link = document.querySelector('#support-link');
  if (!modal || !close || !link) return;

  let before = null;
  const hide = () => {
    if (!modal.classList.contains('on')) return;
    modal.classList.remove('on');
    modal.setAttribute('aria-hidden', 'true');
    if (before && typeof before.focus === 'function') before.focus();
  };
  const show = () => {
    before = document.activeElement;
    modal.classList.add('on');
    modal.setAttribute('aria-hidden', 'false');
    close.focus();
  };

  // Q276 — 여는 문은 메뉴 › 시스템 › 「후원 · 후원자 칭호」 칸 하나다(act.menuOpen → unige:support). 전에는 [더보기] 팔레트 마지막 줄
  addEventListener('unige:support', show);
  close.addEventListener('click', hide);
  modal.addEventListener('click', (e) => { if (e.target === modal) hide(); });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') hide(); });
  link.addEventListener('click', hide);
}
